import React from 'react';
import './App.css';
import { Resume } from './pages/Resume';
import { Switch, Route } from 'react-router-dom'
import { Plans } from './pages/Plans'
import { Nav } from './components/Nav';

import { makeStyles } from '@material-ui/core/styles'

import { About } from './components/About';
import { Websites } from './components/Websites';
import { Projects } from './components/Projects';
import { Team } from './components/Team';
import { FootLinks } from './components/FootLinks';
import { Message } from './components/Message'
import {Footer} from './components/Footer'
function App() {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Nav />
      <Switch>
        <Route exact path='/' component={Resume} />
        <Route exact path='/plan' component={Plans} />
      </Switch>
      <About />
      <Projects />
      <Websites />
      <Team />
      <FootLinks />
      <Message />
      <Footer/>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#0a192f',
    },
    [theme.breakpoints.up('md')]: {
      backgroundColor: '#303c55',
    },
    [theme.breakpoints.up('lg')]: {
      backgroundColor: '#172a45',
    },
  },
}));

export default App;
